export default __webpack_public_path__ + "img/users.c77cebc4.svg";